import { useState, useEffect, useCallback } from 'react';
import { leaderboardEvents, LeaderboardEvent } from '../api/leaderboard-events';
import { useLoader } from '../contexts/LoaderContext';
import { useAlert } from '../contexts/AlertContext';

export const useLeaderboardEventsList = () => {
  const [events, setEvents] = useState<LeaderboardEvent[]>([]);
  const [currentEvent, setCurrentEvent] = useState<LeaderboardEvent | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const { showLoader, hideLoader } = useLoader();
  const { showAlert } = useAlert();

  const fetchEvents = useCallback(async () => {
    try {
      setIsLoading(true);
      showLoader();
      const response = await leaderboardEvents.getList();
      setEvents(response.events);
      setCurrentEvent(response.currentEvent);
    } catch (error) {
      console.error('Failed to fetch leaderboard events:', error);
      showAlert('Failed to fetch leaderboard events', 'error');
    } finally {
      setIsLoading(false);
      hideLoader();
    }
  }, [showLoader, hideLoader, showAlert]);

  useEffect(() => {
    fetchEvents();
  }, [fetchEvents]);

  return {
    events,
    currentEvent,
    isLoading,
    refetch: fetchEvents,
  };
};
